import { FilterAction } from '@anytag/shared-types';
import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { AdCampaignReportFilterFormValues } from './schemaTypes';

type AdCampaignReportFilterProps = FilterAction<AdCampaignReportFilterFormValues>;

export const AdCampaignReportFilter = ({ filter, setFilter }: AdCampaignReportFilterProps) => (
  <Filter.Provider onSubmit={setFilter} values={filter}>
    <Template />
  </Filter.Provider>
);

export * from './hooks';
export * from './schemaTypes';
